module.exports = __webpack_public_path__ + "img/b703f85.jpg";